import { render, staticRenderFns } from "./booyComponent.vue?vue&type=template&id=c0a5dcca&scoped=true"
var script = {}
import style0 from "./booyComponent.vue?vue&type=style&index=0&id=c0a5dcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a5dcca",
  null
  
)

export default component.exports